import React, { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { addRecentAsset } from '@/shared/lib/storage/recentAssets';
import { buildAssetDetailUrl } from '@/shared/lib/url';
import type { FavoriteAssetItem } from '@/shared/types/assetList';
import { AssetListCard } from '@/shared/ui/AssetListCard';

import { FavoritesTab } from '@/widgets/home/FavoritesTab';

export const FavoritesCard: React.FC = () => {
  const navigate = useNavigate();

  const handleAssetClick = useCallback(
    (asset: FavoriteAssetItem) => {
      try {
        addRecentAsset({
          id: asset.id,
          name: asset.name,
          type: asset.type,
          fqn: asset.fqn,
          viewedAt: dayjs().toISOString(),
          ...(asset.projectId && { projectId: asset.projectId }),
          ...(asset.experimentId && { experimentId: asset.experimentId }),
          ...(asset.experimentName && { experimentName: asset.experimentName }),
        });
      } catch (error) {
        console.error('Failed to add recent asset:', error);
      }
      const detailUrl = asset.fqn.startsWith('/experiments/')
        ? asset.fqn
        : buildAssetDetailUrl(asset.type, asset.fqn, undefined, asset.id, asset.projectId);
      navigate(detailUrl);
    },
    [navigate]
  );

  return (
    <AssetListCard title="즐겨찾기">
      <FavoritesTab onAssetClick={handleAssetClick} />
    </AssetListCard>
  );
};
